import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { FeesService } from '../../../../fees.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { NotificationsService } from 'angular2-notifications';
import { StorageUtil } from '../../../../store';

@Component({
  selector: 'app-tryout-basic-info',
  templateUrl: './tryout-basic-info.component.html',
  styleUrls: ['./tryout-basic-info.component.css']
})
export class TryoutBasicInfoComponent implements OnInit {
  public basicFeeInfoForm: FormGroup;
  public programId: Number;
  public routeParams;
  public isStep1WizardNextButtonClicked = 0;
  public dateValue: Date = new Date();
  public onlyDigitPattern = /^-?(0|[1-9]\d*)?$/;
  public alphaNumericPattern = /^[a-zA-Z0-9_ ]+$/;
  public flagPostalCode = true;

  public gradeRanges: any[] = [
    { 'key': -1, 'value': 'Pre K' },
    { 'key': 0, 'value': 'K' },
    { 'key': 1, 'value': '1st' },
    { 'key': 2, 'value': '2nd' },
    { 'key': 3, 'value': '3rd' },
    { 'key': 4, 'value': '4th' },
    { 'key': 5, 'value': '5th' },
    { 'key': 6, 'value': '6th' },
    { 'key': 7, 'value': '7th' },
    { 'key': 8, 'value': '8th' },
    { 'key': 9, 'value': '9th' },
    { 'key': 10, 'value': '10th' },
    { 'key': 11, 'value': '11th' },
    { 'key': 12, 'value': '12th' }
  ];

  public errorMessagesBasicFeeInfoForm = {
    'errorFeeNameRequired': 'This field is required.',
    'errorFeeNameMaxlength': 'Please enter no more than 30 characters.',
    'errorGenderRequired': 'This field is required.',
    'errorMaxPlayersOption': 'Please select an option.',
    'errorMaxPlayersMaxRequired': 'This field is required.',
    'errorMaxPlayersMaxlength': 'Please enter no more than 10 number.',
    'errorMaxPlayersPattern': 'Please enter only number.',
    'errorWaitlistOption': 'Please select an option.',
    'errorWaitlistRequired': 'This field is required.',
    'errorWaitlistMaxlength': 'Please enter no more than 10 number.',
    'errorWaitlistPattern': 'Please enter only number.',
    'errorAgeRangeOption': 'Please select an option.',
    'errorAgeRangeFromRequired': 'This field is required.',
    'errorAgeRangeToRequired': 'This field is required.',
    'errorGradeRangeOption': 'Please select an option.',
    'errorGradeFromRequired': 'This field is required.',
    'errorGradeToRequired': 'This field is required.',
    'errorPostalCodeOption': 'Please select an option.',
    'errorPostalCodeRequired': 'This field is required.',
  };

  public errorMessages = {
    'errorblockAlphabetAndSpecialChar': 'Please enter only number and hyphen.',
    'errorMinValue': 'Please enter at least 5 characters.',
    'errorMaxValue': 'Please enter no more than 10 characters.',
    'errorStartsWithDigit': 'Please start postal code with number.',
    'errorEndsWithDigit': 'Please end postal code with number.',
  };

  public validators = [
    this.blockAlphabetAndSpecialChar,
    this.validateMinValue,
    this.validateMaxValue,
    this.startsWithDigit,
    this.endsWithDigit,
  ];

  constructor(
    private activeRoute: ActivatedRoute,
    private router: Router,
    private feesService: FeesService,
    private notificationsService: NotificationsService,
    private spinnerService: Ng4LoadingSpinnerService,
    private fb: FormBuilder) {
  }

  ngOnInit() {
    this.routeParams = this.activeRoute.snapshot.params;
    this.programId = this.routeParams.id;

    this.basicFeeInfoForm = this.fb.group({
      fee_name: ['', Validators.compose([Validators.required, Validators.maxLength(30),
      Validators.pattern(this.alphaNumericPattern)])],
      gender: ['', Validators.required],
      maxplayersenabled: ['0'],
      playersMaxValue: [{ value: '', disabled: true }, Validators.compose([Validators.required, Validators.maxLength(10),
      Validators.pattern(this.onlyDigitPattern)])],
      waitlistenabled: ['', Validators.required],
      waitlistMaxValue: [{ value: '', disabled: true }, Validators.compose([Validators.required, Validators.maxLength(10),
      Validators.pattern(this.onlyDigitPattern)])],
      dobrangeenabled: ['', Validators.required],
      ageRangeFrom: [{ value: '', disabled: true }, Validators.required],
      ageRangeTo: [{ value: '', disabled: true }, Validators.required],
      graderangeenabled: ['', Validators.required],
      gradeRangeFrom: [{ value: '', disabled: true }, Validators.required],
      gradeRangeTo: [{ value: '', disabled: true }, Validators.required],
      postcodeenabled: ['', Validators.required],
      postal_code: ['', Validators.required]
    }, {
      validator: [this.dateLessThan('ageRangeFrom', 'ageRangeTo'),
      this.gradeLessThan('gradeRangeFrom', 'gradeRangeTo')]
    });

    if (typeof this.routeParams.feeId !== 'undefined') {
      this.getFeeData(this.routeParams.feeId);
    }

    this.maxPlayersChange();
  }

  getFeeData(fee_id: number) {
    this.spinnerService.show();
    this.feesService.getFees(fee_id.toString()).subscribe((response: any) => {
      console.log('getFeeData()', response.data);
      const da = response.data;

      this.basicFeeInfoForm.patchValue({
        fee_name: da.name,
        gender: da.gender,
        maxplayersenabled: da.maxplayersenabled.toString(),
        playersMaxValue: da.maxplayersvalue,
        waitlistenabled: da.waitlistenabled.toString(),
        // waitlistMaxValue: da.waitlistvalue,
        dobrangeenabled: da.dobrangeenabled.toString(),
        ageRangeFrom: da.dobfromdate,
        ageRangeTo: da.dobtodate,
        graderangeenabled: da.graderangeenabled.toString(),
        gradeRangeFrom: da.gradefrom,
        gradeRangeTo: da.gradeto,
        postcodeenabled: da.postcodeenabled.toString(),
      });

      if (da.postcoderange) {
        const postal_code_arr = (da.postcoderange).split(',');
        this.basicFeeInfoForm.get('postal_code').patchValue(postal_code_arr);
      }

      this.maxPlayersSelection();
      this.waitlistSelection();
      this.basicFeeInfoForm.get('waitlistMaxValue').patchValue(da.waitlistvalue);
      this.ageRangeSelection();
      this.gradeRangeSelection();
      this.postalCodeSelection();

      this.spinnerService.hide();
    });
  }

  dateLessThan(from: string, to: string) {
    return (group: FormGroup): { [key: string]: any } => {
      const f = group.controls[from];
      const t = group.controls[to];
      if (f.value > t.value) {
        return {
          ageRangeDates: `"To Date" cannot be before "The From Date".`
        };
      }
    };
  }

  gradeLessThan(gradeRangeFrom: string, gradeRangeTo: string) {
    return (group: FormGroup): { [key: string]: any } => {
      const f = group.controls[gradeRangeFrom];
      const t = group.controls[gradeRangeTo];
      if (parseInt(f.value, 0) > parseInt(t.value, 0)) {
        return {
          gradeRangeValidationMessage: 'To Grade cannot be before The From grade.'
        };
      }
    };
  }

  blockAlphabetAndSpecialChar(control: FormControl) {
    const regex = /^[0-9 \-]+$/;
    const val = control.value;
    if (!regex.test(val)) {
      return { 'errorblockAlphabetAndSpecialChar': true };
    }
    return null;
  }

  private validateMinValue(control: FormControl) {
    if (control.value.length < 5) {
      return { 'errorMinValue': true };
    }
    return null;
  }

  private validateMaxValue(control: FormControl) {
    if (control.value.length > 10) {
      return { 'errorMaxValue': true };
    }
    return null;
  }

  private startsWithDigit(control: FormControl) {
    const reg = /^\d+$/;
    if (!reg.test(control.value.charAt(0))) {
      return { 'errorStartsWithDigit': true };
    }
    return null;
  }

  private endsWithDigit(control: FormControl) {
    const reg = /^\d+$/;
    if (!reg.test(control.value.charAt(control.value.length - 1))) {
      return { 'errorEndsWithDigit': true };
    }
    return null;
  }

  maxPlayersSelection() {
    if (this.isMaxPlayerYesSelected()) {
      this.requiredValidaion('playersMaxValue');
      this.requiredValidaion('waitlistenabled');
    } else {
      this.removeValidaion('playersMaxValue');
      this.removeValidaion('waitlistenabled');
    }
    this.removeValidaion('waitlistMaxValue');
  }

  maxPlayersChange(event = null) {
    if (event)
      event.stopPropagation();

    this.maxPlayersSelection();
  }

  waitlistSelection() {
    if (this.isWaitListYesSelected()) {
      this.requiredValidaion('waitlistMaxValue');
    } else {
      this.removeValidaion('waitlistMaxValue');
    }
  }

  waitlistChange(event) {
    event.stopPropagation();
    this.waitlistSelection();
  }

  ageRangeSelection() {
    if (this.isAgeRangeYesSelected()) {
      this.requiredValidaion('ageRangeFrom');
      this.requiredValidaion('ageRangeTo');
    } else {
      this.removeValidaion('ageRangeFrom');
      this.removeValidaion('ageRangeTo');
    }
  }

  ageRangeChange(event) {
    event.stopPropagation();
    this.ageRangeSelection();
  }

  gradeRangeSelection() {
    if (this.isGradeRangeYesSelected()) {
      this.requiredValidaion('gradeRangeFrom');
      this.requiredValidaion('gradeRangeTo');
    } else {
      this.removeValidaion('gradeRangeFrom');
      this.removeValidaion('gradeRangeTo');
    }
  }

  gradeRangeChange(event) {
    event.stopPropagation();
    this.gradeRangeSelection();
  }

  postalCodeSelection() {
    this.flagPostalCode = !this.isPostalYesSelected();
    if (!this.flagPostalCode) {
      this.requiredValidaion('postal_code');
    } else {
      this.removeValidaion('postal_code');
    }
  }

  postalCodeChange(event) {
    event.stopPropagation();
    this.postalCodeSelection();
  }

  isGenderValid() {
    return this.basicFeeInfoForm.get('gender').errors
      && (this.basicFeeInfoForm.get('gender').touched
        || this.basicFeeInfoForm.get('gender').dirty);
  }

  isMaxPlayerEnabledValid() {
    return this.basicFeeInfoForm.get('maxplayersenabled').errors
      && (this.basicFeeInfoForm.get('maxplayersenabled').touched
        || this.basicFeeInfoForm.get('maxplayersenabled').dirty);
  }

  isMaxPlayerValid() {
    return this.basicFeeInfoForm.get('playersMaxValue').errors
      && (this.basicFeeInfoForm.get('playersMaxValue').touched
        || this.basicFeeInfoForm.get('playersMaxValue').dirty);
  }

  isMaxPlayerYesSelected() {
    return (!!this.basicFeeInfoForm.get('maxplayersenabled'))
      && (this.basicFeeInfoForm.get('maxplayersenabled').value === '1');
  }

  isWaitListEnabledValid() {
    return this.basicFeeInfoForm.get('waitlistenabled').errors
      && (this.basicFeeInfoForm.get('waitlistenabled').touched
        || this.basicFeeInfoForm.get('waitlistenabled').dirty);
  }

  isWaitListValid() {
    return this.basicFeeInfoForm.get('waitlistMaxValue').errors
      && (this.basicFeeInfoForm.get('waitlistMaxValue').touched
        || this.basicFeeInfoForm.get('waitlistMaxValue').dirty);
  }

  isWaitListYesSelected() {
    return (!!this.basicFeeInfoForm.get('waitlistenabled'))
      && (this.basicFeeInfoForm.get('waitlistenabled').value === '1');
  }

  isAgeRangeFromValid() {
    return this.basicFeeInfoForm.get('ageRangeFrom').errors
      && (this.basicFeeInfoForm.get('ageRangeFrom').touched
        || this.basicFeeInfoForm.get('ageRangeFrom').dirty);
  }

  isAgeRangeEnabledValid() {
    return this.basicFeeInfoForm.get('dobrangeenabled').errors
      && (this.basicFeeInfoForm.get('dobrangeenabled').touched
        || this.basicFeeInfoForm.get('dobrangeenabled').dirty);
  }

  isAgeRangeToValid() {
    return this.basicFeeInfoForm.get('ageRangeTo').errors
      && (this.basicFeeInfoForm.get('ageRangeTo').touched
        || this.basicFeeInfoForm.get('ageRangeTo').dirty);
  }

  isAgeRangeYesSelected() {
    return (!!this.basicFeeInfoForm.get('dobrangeenabled'))
      && (this.basicFeeInfoForm.get('dobrangeenabled').value === '1');
  }

  isGradeRangeEnabledValid() {
    return this.basicFeeInfoForm.get('graderangeenabled').errors
      && (this.basicFeeInfoForm.get('graderangeenabled').touched
        || this.basicFeeInfoForm.get('graderangeenabled').dirty);
  }

  isGradeRangeFromValid() {
    return this.basicFeeInfoForm.get('gradeRangeFrom').errors
      && (this.basicFeeInfoForm.get('gradeRangeFrom').touched
        || this.basicFeeInfoForm.get('gradeRangeFrom').dirty);
  }

  isGradeRangeToValid() {
    return this.basicFeeInfoForm.get('gradeRangeTo').errors
      && (this.basicFeeInfoForm.get('gradeRangeTo').touched
        || this.basicFeeInfoForm.get('gradeRangeTo').dirty);
  }

  isGradeRangeYesSelected() {
    return (!!this.basicFeeInfoForm.get('graderangeenabled'))
      && (this.basicFeeInfoForm.get('graderangeenabled').value === '1');
  }

  isPostalRangeEnabledValid() {
    return this.basicFeeInfoForm.get('postcodeenabled').errors
      && (this.basicFeeInfoForm.get('postcodeenabled').touched
        || this.basicFeeInfoForm.get('postcodeenabled').dirty);
  }

  isPostalRangeValid() {
    return this.basicFeeInfoForm.get('postal_code').errors
      && (this.basicFeeInfoForm.get('postal_code').touched
        || this.basicFeeInfoForm.get('postal_code').dirty);
  }

  isPostalYesSelected() {
    return (!!this.basicFeeInfoForm.get('postcodeenabled'))
      && (this.basicFeeInfoForm.get('postcodeenabled').value === '1');
  }

  isWaitListVisible() {
    const isWaitListVisible = this.isMaxPlayerYesSelected();
    if (isWaitListVisible === false) {
      this.basicFeeInfoForm.get('waitlistenabled').reset();
    }
    return isWaitListVisible;
  }

  removeValidaion(name) {
    const control = this.basicFeeInfoForm.get(name);
    control.reset();
    control.disable();
    control.clearValidators();
    control.updateValueAndValidity();
  }

  requiredValidaion(name) {
    const control = this.basicFeeInfoForm.get(name);
    control.enable();
    control.setValidators([Validators.required]);
    control.updateValueAndValidity();
  }

  nextWizardStep(event, step_number, form_status) {
    event.stopPropagation();
    this.isStep1WizardNextButtonClicked = 1;
    this.validateUi();

    if (form_status === 'VALID') {
      const postal_code_value = this.basicFeeInfoForm.value.postal_code;
      const fee_id = this.routeParams.feeId;
      const obj = {
        FeeID: (typeof fee_id === 'undefined') ? 0 : fee_id.toString(),
        clubprogramID: Number(this.programId),
        Addedby: StorageUtil.userID,
        Name: this.basicFeeInfoForm.value.fee_name,
        Gender: this.basicFeeInfoForm.value.gender,
        Dobrangeenabled: this.basicFeeInfoForm.value.dobrangeenabled,
        Dobfromdate: this.basicFeeInfoForm.value.ageRangeFrom,
        Dobtodate: this.basicFeeInfoForm.value.ageRangeTo,
        Maxplayersenabled: this.basicFeeInfoForm.value.maxplayersenabled,
        Maxplayersvalue: this.basicFeeInfoForm.value.playersMaxValue,
        Waitlistenabled: this.basicFeeInfoForm.value.waitlistenabled,
        Waitlistvalue: this.basicFeeInfoForm.value.waitlistMaxValue,
        Graderangeenabled: this.basicFeeInfoForm.value.graderangeenabled,
        Gradefrom: this.basicFeeInfoForm.value.gradeRangeFrom,
        Gradeto: this.basicFeeInfoForm.value.gradeRangeTo,
        Postcodeenabled: this.basicFeeInfoForm.value.postcodeenabled,
        Postcoderange: (postal_code_value === undefined) ? postal_code_value : postal_code_value.toString(),
        Setup: 1
      };

      // Progress UI On
      event.target.innerHTML = 'Saving <i class="fa fa-spinner fa-spin push-5-r"></i>';
      event.target.disabled = true;
      this.feesService.createBasicFeeInfo(obj).subscribe((data: any) => {
        // Progress UI Off
        event.target.innerHTML = 'Next <i class="fa fa-arrow-right"></i>';
        event.target.disabled = false;
        this.alertMessage('success', data.result);
        const RP = this.routeParams;
        this.router.navigate(['/tryoutprogram/' + RP.name + '/' + RP.id + '/' + RP.status + '/fee/step2/' + data.feeId]);
      }, error => {
        console.error(error);
        this.alertMessage('error', error.statusText);
      });
    }
  }

  validateUi() {
    Object.keys(this.basicFeeInfoForm.controls).forEach(field => {
      const control = this.basicFeeInfoForm.get(field);
      control.markAsTouched({ onlySelf: true });
    });
  }

  alertMessage(status, message) {
    if (status === 'success') {
      const toast = this.notificationsService.success('Success', message, {
        timeOut: 3000,
        showProgressBar: true,
        pauseOnHover: false,
        clickToClose: false
      });
    } else if (status === 'error') {
      const toast = this.notificationsService.error('Error', message, {
        timeOut: 3000,
        showProgressBar: true,
        pauseOnHover: false,
        clickToClose: false
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/tryout/pages/tryout-fee/tryout-basic-info/tryout-basic-info.component.ts